import React from 'react'
import { useTrans } from 'hooks'
import { ListingHead, Page, PowerBar } from 'components/organisms'
import styles from './BlogTemplate.module.sass'
import { NewsNode, PaginaNode } from '@gql/graphql'
import { ArticoloCard } from '@components/molecules'
import { Button, WContainer } from '@components/atoms'

interface Props {
  pagina?: PaginaNode
  articoli?: NewsNode[]
  handleMore?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  powerBarItems?: {
    pk: number
    name: string
    selected: boolean
    url: string
  }[]
  loading?: boolean
  nextPageLength?: number
  linkNextPage?: string
  buttonUrl?: boolean
}

const BlogTemplate = (props: Props) => {
  const {
    pagina = undefined,
    articoli = undefined,
    powerBarItems = [],
    handleMore = undefined,
    loading = false,
    nextPageLength = undefined,
    linkNextPage = undefined,
    buttonUrl = false,
  } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main className={styles.layout}>
        <ListingHead pagina={pagina} />
        <PowerBar items={powerBarItems} />
        <WContainer>
          <div className={styles.main}>
            <div className={styles.list}>
              {articoli?.map((n, index) => (
                <React.Fragment key={n.pk}>
                  <ArticoloCard
                    news={n}
                    titleVariant="h2"
                    variant={index === 0 && n.previewImage ? 'main' : ''}
                    className={`${styles.item} ${
                      index === 0 && n.previewImage ? styles['item--full'] : ''
                    }`}
                  />
                </React.Fragment>
              ))}
            </div>
            {nextPageLength > 0 && (
              <div className={styles.ctaBox}>
                <Button
                  label={t(
                    nextPageLength === 1
                      ? 'Carica {0} altro articolo'
                      : 'Carica altri {0} articoli',
                    [nextPageLength.toString()]
                  )}
                  variant="secondary"
                  onClick={handleMore}
                  loading={loading}
                  href={buttonUrl ? linkNextPage : null}
                />
              </div>
            )}
          </div>
        </WContainer>
      </main>
    </Page>
  )
}

export default BlogTemplate
